<template>
  <a-popover
    v-model="visible"
    trigger="click"
    placement="bottomRight"
    overlayClassName="header-notice-wrapper"
    :autoAdjustOverflow="true"
    :arrowPointAtCenter="true"
    :overlayStyle="{ width: '300px', top: '50px' }"
  >
    <template slot="content">
      <a-spin :spinning="loading">
        <h3 style="text-align:center;">我的消息</h3>
        <a-list :dataSource="messages" :locale="{ emptyText: '暂无未读消息' }" size="small">
          <a-list-item slot="renderItem" slot-scope="item">
            <a-list-item-meta :description="item.gmtCreate">
              <a href="#" slot="title" @click="toMessage(item.id)">
                {{ item.title }}
              </a>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
      </a-spin>
    </template>
    <span @click="fetchNotice" class="header-notice">
      <a-badge :count="count">
        <a-icon style="font-size: 16px; padding: 4px" type="bell" />
      </a-badge>
    </span>
  </a-popover>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { encrypt } from '@/utils/util'
import { pageMessages } from '@/api/message'

export default {
  name: 'HeaderNotice',
  inject: ['reload'],
  data () {
    return {
      loading: false,
      visible: false,
      query: {
        isRead: false,
        prop: '',
        direction: '',
        pageSize: 3,
        pageNumber: 0
      },
      count: 0,
      messages: []
    }
  },

  computed: {
    messageNumber () {
      return this.messageNum()
    }
  },

  watch: {
    messageNumber (val) {
      this.count = val
    }
  },

  mounted () {
    this.timer = setInterval(() => {
      this.periodCount()
    }, 12000)
    console.log('消息定时器已创建')
  },

  methods: {
    ...mapActions(['FetchMessageNum']),

    ...mapGetters(['messageNum']),

    encrypt,

    fetchNotice () {
      if (!this.visible) {
        this.loading = true
        pageMessages(this.query).then(response => {
          this.messages = response.data.content
        }).catch(err => {
          console.log(err)
        }).finally(() => {
          this.loading = false
        })
      }
      this.visible = !this.visible
    },

    toMessage (id) {
      this.visible = !this.visible
      this.$router.push({ name: 'MessageDetail', query: { id: this.encrypt(id) } })
      if (this.$route.path.startsWith('/message/detail')) {
        this.reload()
      }
    },

    periodCount () {
      const { FetchMessageNum } = this
      FetchMessageNum().then().catch(err => {
        console.log(err)
      })
    }
  }
}
</script>

<style lang="css">
  .header-notice-wrapper {
    top: 50px !important;
  }
</style>
<style lang="less" scoped>
  .header-notice{
    display: inline-block;
    transition: all 0.3s;

    span {
      vertical-align: initial;
    }
  }
</style>
